export const UPLOAD_LOGO = 'UPLOAD_LOGO';

export const GET_PRESIGNED_UPLOAD_URL_REQUEST = 'GET_PRESIGNED_UPLOAD_URL_REQUEST';
export const GET_PRESIGNED_UPLOAD_URL_SUCCESS = 'GET_PRESIGNED_UPLOAD_URL_SUCCESS';
export const GET_PRESIGNED_UPLOAD_URL_FAILURE = 'GET_PRESIGNED_UPLOAD_URL_FAILURE';

export const CONFIRM_LOGO_UPLOAD_REQUEST = 'CONFIRM_LOGO_UPLOAD_REQUEST';
export const CONFIRM_LOGO_UPLOAD_SUCCESS = 'CONFIRM_LOGO_UPLOAD_SUCCESS';
export const CONFIRM_LOGO_UPLOAD_FAILURE = 'CONFIRM_LOGO_UPLOAD_FAILURE';

export const DELETE_PRINTING_LOGO_REQUEST = 'DELETE_PRINTING_LOGO_REQUEST';
export const DELETE_PRINTING_LOGO_SUCCESS = 'DELETE_PRINTING_LOGO_SUCCESS';
export const DELETE_PRINTING_LOGO_FAILURE = 'DELETE_PRINTING_LOGO_FAILURE';

export const FETCH_PRINTING_LOGO_REQUEST = 'FETCH_PRINTING_LOGO_REQUEST';
export const FETCH_PRINTING_LOGO_SUCCESS = 'FETCH_PRINTING_LOGO_SUCCESS';
export const FETCH_PRINTING_LOGO_FAILURE = 'FETCH_PRINTING_LOGO_FAILURE';

export const SET_PRINTING_LOGO_CLIENT_ERROR = 'SET_PRINTING_LOGO_CLIENT_ERROR';
export const CLEAR_PRINTING_LOGO_ERROR = 'CLEAR_PRINTING_LOGO_ERROR';
